import { createColumnsService } from "./factory";
import type { IColumnsService } from "./types";

export const columnsService: IColumnsService = createColumnsService();
